import { ArrowRightOutlined } from '@ant-design/icons';
import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import { CollegamentoRichiestaDTOTipo } from '@framework/api-client/api/inquiries-compile/schemas/collegamentoRichiestaDTOTipo.ts';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { SubmissionLinkLogic } from '@framework/frontoffice-submission/link/SubmissionLinkLogic.ts';
import { LinkedSubmissionCard } from '@framework/frontoffice-submission/submission/linked/LinkedSubmissionCard.tsx';
import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import {
  generatePath,
  useHistory,
} from '@framework/ui/core/router/TypedRoute.tsx';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

export interface ISubmissionLinkedBoxProps {
  submission?: RichiestaDTO | null;
  inquiry?: TipoDomandaDTO | null;
}

/**
 * Banner di collegamento a una richiesta collegata per il frontoffice
 */
export function SubmissionLinkedBox(props: ISubmissionLinkedBoxProps) {
  const { submission, inquiry } = props;
  const history = useHistory();
  const { t } = useTranslation();
  if (!submission || !inquiry) return null;

  const hasLinkedInquiry = inquiry.tipoDomandaOsservata;
  const linkedSubmission = SubmissionLinkLogic.getFirstOutboundLink(
    submission.collegamenti,
    CollegamentoRichiestaDTOTipo.OSSERVAZIONE,
  );

  if (!linkedSubmission || !hasLinkedInquiry) return null;

  return (
    <div>
      <LinkedSubmissionCard
        dark
        action={
          <Button
            size="large"
            onClick={() => {
              history.push(
                generatePath('/area-pubblica/:id', {
                  id: linkedSubmission.idRichiesta ?? '',
                }),
              );
            }}
          >
            {t(
              'submission-linked-button.visualizza-richiesta',
              'Visualizza richiesta',
            )}{' '}
            <ArrowRightOutlined />
          </Button>
        }
        summary={linkedSubmission.tipo}
        linkedSubmissionId={linkedSubmission.idRichiesta}
        title={inquiry.tipoDomandaOsservata?.titolo ?? undefined}
      />
      <VerticalSpace size={16} />
    </div>
  );
}
